// composables/useToggleCheck.ts
// Checks whether a toggle feature stored in localStorage is currently active
import moment from "moment";

export function useToggleCheck(toggle: string, isGeneral = false): boolean {
  let toggleData: Record<string, any> = {};

  if (isGeneral) {
    toggleData = usePublicInfoStore().toggleGeneral || {};
  } else {
    const raw = localStorage.getItem("toggleList");
    const toggleList = raw ? JSON.parse(raw) : [];

    if (!Array.isArray(toggleList)) return false;

    toggleData =
      toggleList.find((feature) => feature.name === toggle) || {};
  }

  if (
    Object.keys(toggleData).length === 0 ||
    !toggleData?.startTime ||
    !toggleData?.endTime
  )
    return false;

  const sanitizeFormatDate = (date: string) => date.replace("  ", " ");

  const start = moment(sanitizeFormatDate(toggleData.startTime));
  const end = moment(sanitizeFormatDate(toggleData.endTime));
  const now = moment();
  const isToggleAvailable = toggleData?.status;

  return isToggleAvailable && now.isBetween(start, end, null, "[]");
}
